import { render, staticRenderFns } from "./UrlAppInventaireAdmin.vue?vue&type=template&id=130c4515&"
import script from "./UrlAppInventaireAdmin.vue?vue&type=script&lang=ts&"
export * from "./UrlAppInventaireAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./UrlAppInventaireAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports